import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';

const TAG = 'AmapMarker';

@Injectable()
export class AmapMarkerService implements Getter<AMap.Marker> {
  private marker: AMap.Marker;
  private marker$ = new ReplaySubject<AMap.Marker>(1);

  constructor(private amaps: AMapService, private logger: LoggerService, private ngZone: NgZone) {}

  /**
   * è·åç¹æ è®°
   */
  get() {
    return this.marker$.asObservable();
  }

  /**
   * åå»ºç¹æ è®° AMap.Marker
   * @param options éé¡¹
   * @param addToMap æ¯å¦ç´æ¥å è¿å°å¾
   */
  create(options: AMap.Marker.Options, addToMap = true) {
    return this.amaps.get().pipe(
      map(m => {
        if (addToMap) {
          options.map = m;
        }
        this.marker = this.ngZone.runOutsideAngular(() => new AMap.Marker(options));
        this.logger.d(TAG, 'new marker created.');
        this.marker$.next(this.marker);
        this.marker$.complete();
        return this.marker;
      }),
    );
  }

  /**
   * éæ¯ç¹æ è®°
   */
  destroy() {
    this.get().subscribe(m => {
      m.setMap(null);
      this.logger.d(TAG, 'marker destroyed.');
      this.marker = null;
    });
  }
}
